import { render } from "./singleFileUpload.vue?vue&type=template&id=2543d2a2&scoped=true"
import script from "./singleFileUpload.vue?vue&type=script&lang=js"
export * from "./singleFileUpload.vue?vue&type=script&lang=js"

import "./singleFileUpload.vue?vue&type=style&index=0&id=2543d2a2&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2543d2a2"]])

export default __exports__